import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { LabelZoneIndicator } from "../../../components/common/LabelZoneIndicator";
// import image from "../../../assets/imgs/Group.svg";
import image5s from "../../../assets/imgs/group-activity5S.png";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	modalsubactivityOne: 2,
	gameSubactivityOne: 3,
	dialogTwo: 4,
	dialogThree: 5,
	dialogfour: 6,
	dialogfive: 7,
	dialogsix: 8,
	dialogseven: 9,
	dialogEight: 10,
	activityInfo: 20,
};

export const SubtopicTwoActivityThree = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema2], 3);
	useEffect(() => {
		if (loaded) {
			console.log("subtema two Activity three");
			ObserverEmitter.emit(EVENTS.subtopicTwo.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act3_a01)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicTwo.initScene, 3);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 3: Metodología 5’s+1." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Todo el proceso realizado nos lleva a la  Metodología de las 5's + 1 la cual consiste en 5 principios los cuales van a ir enfocados en lograr obtener un lugar de trabajo organizado limpio ordenado y productivo."}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.activityInfo);
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.activityInfo && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Abasto en tienda."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.gameSubactivityOne);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.gameSubactivityOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<div className="fixed z-20 top-0 w-full h-full flex items-end pt-2">
						<div className="h-[calc(100%-80px)] md:h-[calc(100%-85px)] flex justify-center items-center w-full relative overflow-hidden">
							<div className="h-[240px] w-[352px] md:h-[544px] md:w-[672px] gradiantBlueClient rounded-[32px] relative px-4 py-4">
								<div className="bg-red_primary h-[32px] md:h-[40px] rounded-[30px] py-2 flex justify-center items-center">
									<p className="text-white text-[12px] md:text-[16px]">Información</p>
								</div>
								<div className="h-[calc(100%-32px)] w-full p-3 flex flex-col gap-2">
									<div className="h-[90%] w-full md:p-10">
										<img src={image5s} className="h-full w-full object-contain" alt="" />
									</div>
									<div className="h-[10%] w-full flex justify-center items-center">
										<p className="text-yellow_primary text-[7px] md:text-[14px]">
											El +1 es la aportación que TU vas a dar dentro de tu Tienda siguiendo las 5's
										</p>
									</div>
								</div>
							</div>
							<div
								onClick={() => {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act3_a02)
									ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
									setUiToShow(steps.dialogTwo);
								}}
								className="h-[40px] w-[180px] md:h-[48px] md:w-[268px] rounded-2xl bg-yellow_primary flex justify-center items-center absolute bottom-4 right-4"
							>
								<p className="text-white text-[20px] md:text-[22px]">Continuar</p>
							</div>
						</div>
					</div>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<LabelZoneIndicator btnText={"1. SEISO = Limpieza"} />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"La limpieza es muy importante, ya que ayuda en la calidad de nuestro servicio y depende mucho de tu actitud y la de tus compañeros. "
						}
						percentage={"40%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act3_a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<LabelZoneIndicator btnText={"2. SEITO = Organización"} />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Al acomodar las cosas toma en cuenta que todo sea fácil de localizar y sacar, toma en cuenta el sistema de primeras entradas, primeras salidas."
						}
						percentage={"50%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act3_a04)
							setUiToShow(steps.dialogfour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogfour && (
				<>
					<LabelZoneIndicator btnText={"3. SEIRI = Selección"} />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Con la selección separamos lo que sirve de lo que no sirve. Coloca en las góndolas y exhibidores solo el producto necesario, lo demás puedes guardarlo en la bodega."
						}
						percentage={"60%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act3_a05)
							setUiToShow(steps.dialogfive);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogfive && (
				<>
					<LabelZoneIndicator btnText={"4. SEIKETSU = Disciplina"} />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Con la disciplina y el compromiso te creas el habito de hacer costumbres las buenas acciones en la tienda y al mismo tiempo un ambiente de amistad y respeto entre compañeros."
						}
						percentage={"80%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act3_a06)
							setUiToShow(steps.dialogsix);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogsix && (
				<>
					<LabelZoneIndicator btnText={"5. SEIKETSU = Estandarización"} />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Cumplir una acción que se debe realizar siempre de la misma manera. Al estandarizar procesos agilizas tu dia de trabajo y puedes dejar por escrito lo que hasta el momento has logrado y es mas fácil mantener las cosas de esa forma."
						}
						percentage={"80%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act3_a07)
							// ObserverEmitter.emit(EVENTS.characterAnimations.showModel);
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogseven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogseven && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Y el +1 es la aportación del trabajo en equipo, lo que tu puedas sumar a tu trabajo. Recuerda que esta metodología también la puedes usar en tu vida diaria y te dará un crecimiento continuo."
						}
						percentage={"90%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogEight && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Recuerda es importante llevar un órden dentro de tu área laboral, fomentando el trabajo en equipo."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: 0,
									subtema: tasksId.tema1.activities.subtema2,
								})
							);
							navigator("/home1/tema1/subtema2/activityresult");
						}}
					/>
				</>
			)}
		</>
	);
};
